import React, { useContext } from "react";
import { useCookies } from "react-cookie";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { TimeContext, EventContext, AnalyticsContext } from "Components";
import { fonts } from "theme/fonts";

export const Footer = ({ showFooter, registration, preCampaign }) => {
  const { event } = useContext(EventContext);
  const { logClick } = useContext(AnalyticsContext);
  const [cookies, setCookie] = useCookies();

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  const { maxPolicy, sweepsDisclaimer } = event.footer;
  const registered = cookies.registered ? true : false;

  const linkClickHandler = (label, link) => {
    logClick({
      label,
      url: link,
    });
  };

  return (
    <>
      {showFooter && (
        <FooterWrapper as="footer" preCampaign={preCampaign}>
          <FooterContainer>
            <FooterCopy>
              {sweepsDisclaimer && (
                <SweepsDisclaimer>
                  {sweepsDisclaimer && ReactHtmlParser(sweepsDisclaimer)}
                </SweepsDisclaimer>
              )}
              <MaxPolicy>{ReactHtmlParser(maxPolicy)}</MaxPolicy>
            </FooterCopy>
          </FooterContainer>
        </FooterWrapper>
      )}
    </>
  );
};

const FooterWrapper = styled.footer`
  display: flex;
  flex-direction: row;
  color: #ffffff;
  background-color: #000013;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
  }
`;

// ====== FOOTER COPY ====== //

const FooterCopy = styled.div`
  padding: 25px;
  font-size: 12px;
  text-align: center;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 25px 35px;
    flex: 1;
  }
`;

const SweepsDisclaimer = styled.div`
  & > p {
    margin-top: 0;
  }

  a,
  a:visited {
    color: #ffffff;
  }
`;

const MaxPolicy = styled.p`
  a,
  a:visited {
    color: #ffffff;
  }
`;
